import classes from "./LiveButton.module.scss";
import image from "../icons/liveButton.webp";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { links } from "./config/liveButton";

const LiveButton = () => {
  const isDesktop = useWindowDimensions();

  const handleClick = () => {
    const url = isDesktop ? links.desktop : links.mobile;
    window.open(url, "_blank");
  };

  return (
    <div className={classes.liveButton} onClick={handleClick}>
      <span className={classes.imageWrapper}>
        <img className={classes.image} src={image} width={26} height={26} alt="" />
      </span>
      <div className={classes.textWrapper}>
        <span className={classes.text}>LIVE</span>
      </div>
    </div>
  );
};

export default LiveButton;
